import React from 'react';
import classNames from "classnames";
import { connect } from 'react-redux';

import {
    toggleItemVisibility,
    setPrintDesignOption, setCurrentProjectOption, duplicateProject
} from '../../actions';

//css and images
// import './productOptionPanel.scss';


class ProductDetailOption extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
        this.handleCustomFurtherClicked = this.handleCustomFurtherClicked.bind(this);
    }

    handleVariationClicked(option, variation, e) {
      if (option==="print_design"){
        this.props.setPrintDesignOption(option, variation);
      }else{
        this.props.setCurrentProjectOption(option, variation);
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    handleCustomFurtherClicked() {
        let changes = this.props.customTexts;

        this.props.duplicateProject(this.props.projectCode, changes, this.props.currentProjectOptions, data => {
            if (data && data.status === 'Y') {
                //window.location.href = `${process.env.REACT_APP_ENGINE_HOST}` + data.url
                window.location.href =  data.url
            }
        })
    }

    render() {
      if (!this.props.projectOptions) {
        return null;
      }
      /*
      if (this.props.currentProjectOptions["print_design"]=="" && this.props.max_page==2 && this.props.min_page==1){
        (this.props.pages.length>0 && !this.props.currentProjectOptions["print_design"])?this.props.currentProjectOptions["print_design"]="double":this.props.currentProjectOptions["print_design"]="single"
      }
      */
      return (<div>
          {this.props.projectOptions.options.map(option => {
            return (
                <React.Fragment key={"product_detail_option_" + option.name}>
                    <div className={classNames("row justify-content-start align-items-center")}>
                        <div className={option.name + " label col-3 h6 font-weight-bold m-0"}>{option.displayName}</div>
                        {option.name.indexOf('color')!==-1 ?
                            <div className="col-9">
                                {option.variations.map(variation => {
                                    let img = null;

                                    if(variation.options_variations_img != null && variation.options_variations_img != ""){
                                        img = (<img src={variation.options_variations_img} />);
                                    }

                                    return (
                                        <div key={"variation_" + variation.name}
                                             onMouseUp={this.handleVariationClicked.bind(this, option.name, variation.name)}
                                             className={classNames("color_option_container align-top mr-2 dot", {option_selected: this.props.currentProjectOptions[option.name] == variation.name})}>
                                            {img?img:<div className='dot'
                                                 style={{backgroundColor: variation.select_content ? variation.select_content : variation.displayName}} />}

                                        </div>)
                                }) }
                            </div>

                            : (
                                <div className={option.name + ' col-9'}>
                                        {option.variations.map((variation, index) => {

                                            let img = null;
                                            let displayName = variation.displayName;

                                            if(variation.options_variations_img != null && variation.options_variations_img != ""){
                                                img = (<img alt={"variation "+index} className="variation_img py-2" src={variation.options_variations_img} />);
                                                displayName = null;
                                            }
                                            return (<div key={"variation_" + variation.name} className={classNames("pointer d-inline-flex", {"mx-2":index}, {"mr-2":!index}, {"d-image":!!img}, {option_selected: this.props.currentProjectOptions[option.name] === variation.name})}
                                                     onMouseUp={this.handleVariationClicked.bind(this, option.name, variation.name)}>
                                                        {img}
                                                        {displayName}
                                                </div>)
                                        })}
                                </div>
                            )}
                        <div className={classNames('w-100 d-block border-top', {'mt-2' : option.name !== 'color'})}>&nbsp;</div>
                    </div>


                </React.Fragment>)
          })}


      </div>)
    }
}

const mapStateToProps = state => {
  return {
    pages: state.pages,
    projectOptions: state.projectOptions,
    currentProjectOptions: state.currentProjectOptions,
    projectCode: state.projectCode,
    customTexts: state.customTexts,
    is_customise_further: state.is_customise_further,
    //isCustomPanel: state.itemsVisibility['mobileCustomPanel'],
    max_page: state.max_page,
    min_page: state.min_page,
  }
};

const mapDispatchToProps = dispatch => ({
  toggleItemVisibility: (itemCode) => dispatch(toggleItemVisibility(itemCode)),
  setCurrentProjectOption: (option, variation) => dispatch(setCurrentProjectOption(option, variation)),
  setPrintDesignOption: (option, variation) => dispatch(setPrintDesignOption(option, variation)),
  duplicateProject: (hash, changes, variations, callback) => dispatch(duplicateProject(hash, changes, variations, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailOption);
